import BaseLayer from 'ol/layer/Base';
import "gijgo/js/gijgo";
import { VectorRenderTile } from 'ol';

const getMap = () => {
    return window.VGIS.vMap.Map;
}

class LayerManager {
    constructor() {
        this.layers = {
        }
        this.layerCount = 0;        
    }

    private layerCount: number;

    public get count() {
        return this.layerCount;
    }

    private layers: {
        [key: string]: BaseLayer
    };


    public get(layerName: string) {
        return this.layers[layerName];
    }

    public add(layerName: string, layer: BaseLayer) {
        if (!this.contains(layerName)) {
            this.layerCount++;
            this.layers[layerName] = layer;
        } else {
            this.removeLayer(this.layers[layerName]);
            this.layers[layerName]= layer;
        }

        layer.setZIndex(10);
        getMap().addLayer(layer);
    }

    public remove(layerName:string) {
        if (this.contains(layerName)) {
            this.layerCount--;
            this.removeLayer(this.layers[layerName]);
            delete this.layers[layerName];
        }
    }

    private removeLayer(layer: BaseLayer) {
        getMap().removeLayer(layer);
    }

    public contains(layerName: string) {
        return this.layers[layerName] !== undefined;
    }

    public getAll() {
        return this.layers;
    }

    public show(layerName: string) {
        if (!this.getVisible(layerName)) {
            let layer = this.get(layerName);
            layer.setVisible(true);
        }
    }

    public hide(layerName: string) {
        if (this.getVisible(layerName)) {
            let layer = this.get(layerName);
            layer.setVisible(false);
        }
    }

    public changeVisible(layerName: string, visible: boolean) {
        let layer = this.get(layerName);
        if (layer) {
            layer.setVisible(visible);
        }
    }

    public getVisible(layerName: string) {
        let layer = this.get(layerName);
        if (layer) {
            return layer.getVisible();
        }
        return false;
    }


    public getIterator() {
        let that = this;
        let myIterable = function* () {
            for (var layerKv in that.layers) {
                if (that.layers.hasOwnProperty(layerKv)) {
                    yield layerKv;
                }
            }
        };
        return myIterable;
    }
}


const initLayerManager = () => {
    const layerManager = new LayerManager();
    let tree: Types.Tree;

    tree = $('#mapLayers').tree({
        primaryKey: 'id',
        uiLibrary: 'bootstrap4',
        checkboxes: true
    });

    console.log("tree2", tree)
    tree.on('checkboxChange', function (e, $node, record, state) {
        if (!record.children || record.children.length === 0) {
            let layerName = record.id;
            if (state === "checked") {
                layerManager.show(layerName);
            } else if (state === "unchecked") {
                layerManager.hide(layerName);
            }

        } else {
            //state === indeterminate
        }
        console.log(e, $node, record);
    });
    return layerManager;
}

export { LayerManager };
